module.exports = __webpack_public_path__ + "img/crowd.7dfdb64.png";